import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

export function DormBeanbagSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const span = view === 'left' || view === 'right' ? depth : width;

  return (
    <SchematicShell
      width={span}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      drawFrame={false}
    >
      <g
        transform={
          view === 'right' ? `scale(-1, 1) translate(${-span}, 0)` : undefined
        }
      >
        <BeanbagElevation
          span={span}
          height={height}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      </g>
    </SchematicShell>
  );
}

function BeanbagElevation({ span, height, strokeColor, strokeWidth }) {
  const cx = span / 2;
  const dipW = span * 0.35;
  const dipTopY = height * 0.25;
  const dipBotY = height * 0.4;
  const bulgeTopY = height * 0.08;
  const sideCtrlY = height * 0.15;

  return (
    <g>
      <path
        d={[
          `M ${cx - dipW / 2} ${dipTopY}`,
          `Q ${cx} ${dipBotY} ${cx + dipW / 2} ${dipTopY}`,
          `C ${span * 0.85} ${bulgeTopY} ${span} ${sideCtrlY} ${span} ${height * 0.5}`,
          `Q ${span} ${height * 0.85} ${span * 0.75} ${height}`,
          `L ${span * 0.25} ${height}`,
          `Q 0 ${height * 0.85} 0 ${height * 0.5}`,
          `C 0 ${sideCtrlY} ${span * 0.15} ${bulgeTopY} ${cx - dipW / 2} ${dipTopY}`,
        ].join(' ')}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <Line
        x1={cx}
        y1={dipBotY}
        x2={cx}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.4}
      />
      <Line
        x1={span * 0.25}
        y1={height * 0.2}
        x2={span * 0.28}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.4}
      />
      <Line
        x1={span * 0.75}
        y1={height * 0.2}
        x2={span * 0.72}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.4}
      />
    </g>
  );
}

DormBeanbagSchematic.supportsSideViews = true;
